import { axios } from '@/utils/request'
const api = "/Discounts"
export default {
  DiscountsList: (parameter) => {
    return axios({
      url: `${api}/DiscountsList`,
      method: 'post',
      data: parameter
    })
  },
  deleteDiscounts: (parameter) => {
    return axios({
      url: `${api}/deleteDiscounts`,
      method: 'post',
      data: parameter
    })
  },
  SaveDiscounts: (parameter) => {
    return axios({
      url: `${api}/SaveDiscounts`,
      method: 'post',
      data: parameter
    })
  },
  AddDiscounts: (parameter) => { 
    return axios({
      url: `${api}/AddDiscounts`,
      method: 'post',
      data: parameter
    })
  },
  FindDiscounts: (parameter) => {
    return axios({
      url: `${api}/FindDiscounts`,
      method: 'post',
      data: parameter
    })
  },

}